function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.58764 11.6562L2.74144 22.1873C2.63071 22.597 2.93926 23 3.36362 23H5.29593C5.58713 23 5.84215 22.8048 5.91812 22.5236L8.36772 13.4601L5.58764 11.6562Z",
  fill: "#FFD572"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.50391 6.58594C1.67465 6.58594 1 7.26059 1 8.08984V10.668C1 11.4972 1.67465 12.1719 2.50391 12.1719H4.22266V6.58594H2.50391Z",
  fill: "#FFFD9A"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.825 1.06883L8.36738 5.29683L7.01562 9.37847L8.36738 13.4601L16.825 17.689C17.2536 17.9032 17.7578 17.5916 17.7578 17.1125V1.64564C17.7578 1.16659 17.2536 0.854547 16.825 1.06883Z",
  fill: "#507FC8"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 10.668C1 11.4972 1.67465 12.1719 2.50391 12.1719H4.22266V9.37891H1V10.668Z",
  fill: "#FFD572"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.01562 9.37891L8.36725 13.4601L16.8249 17.689C17.2535 17.9032 17.7577 17.5917 17.7577 17.1126V9.37891H7.01562Z",
  fill: "#6493DC"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.51172 5.29682C4.44554 5.29682 3.57812 6.16414 3.57812 7.23024V11.5267C3.57812 12.5928 4.44554 13.4601 5.51172 13.4601H8.36738V5.29682H5.51172Z",
  fill: "#6E9DE6"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.57812 9.37891V11.5267C3.57812 12.5928 4.44554 13.4601 5.51172 13.4601H8.36738V9.37891H3.57812Z",
  fill: "#507FC8"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.3555 10.0234H20.6367C20.2808 10.0234 19.9922 9.73486 19.9922 9.37891C19.9922 9.02295 20.2808 8.73438 20.6367 8.73438H22.3555C22.7114 8.73438 23 9.02295 23 9.37891C23 9.73486 22.7114 10.0234 22.3555 10.0234Z",
  fill: "#40EBD5"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.9922 9.37891C19.9922 9.73486 20.2808 10.0234 20.6367 10.0234H22.3555C22.7114 10.0234 23 9.73486 23 9.37891H19.9922Z",
  fill: "#40EBD5"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.5117 6.6601C19.39 6.32559 19.5624 5.95575 19.8969 5.83398L21.512 5.24613C21.8465 5.12439 22.2164 5.29683 22.3381 5.63134C22.4598 5.96585 22.2874 6.33568 21.9529 6.45746L20.3378 7.04531C20.0033 7.16704 19.6335 6.99461 19.5117 6.6601Z",
  fill: "#40EBD5"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.512 13.5117L19.8969 12.9238C19.5624 12.8021 19.39 12.4322 19.5117 12.0977C19.6334 11.7632 20.0033 11.5908 20.3378 11.7125L21.9529 12.3004C22.2874 12.4221 22.4598 12.792 22.3381 13.1265C22.2164 13.461 21.8465 13.6334 21.512 13.5117Z",
  fill: "#40EBD5"
});

var SvgNotiActive = function SvgNotiActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotiActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noti_active.325f79f2.svg";
export { ForwardRef as ReactComponent };